import { makeObservable, observable, action } from "mobx";
import axios from "axios";

export class StoreServices {
  isLoaded = false;
  isWorking = false;

  constructor(rootStore) {
    this.rootStore = rootStore;
    this.isWorking = false;

    makeObservable(this, {
      isLoaded: observable,
      isWorking: observable,
      setIsLoaded: action,
      setIsWorking: action,
    });
  }

  setIsLoaded(loaded) {
    this.isLoaded = loaded;
  }

  setIsWorking(value) {
    this.isWorking = value;
  }

  async getServiceStatus(serviceId) {
    let status;
    try {
      const checkUrl = `https://services.airrange.io/api/manageapi?type=check&service=${serviceId}`;
      const response = await axios({
        url: checkUrl,
        method: "GET",
      });
      status = response.data?.status ?? "error";
    } catch (error) {
      console.log("ERROR getServiceStatus", error);
      status = "error";
    }
    return status;
  }

  async getServiceAnalytics(serviceId) {
    let domainId = this.rootStore.main.userDomain;
    const analyticsUrl = `https://services.airrange.io/api/getanalytics?tenant=${domainId}&service=${serviceId}`;
    const response = await axios(analyticsUrl, {
      method: "GET",
      // query URL without using browser cache
      // headers: {
      //   "Cache-Control": "no-cache",
      //   Pragma: "no-cache",
      //   Expires: "0",
      // },
    });
    const analyticsData = response?.data ?? {};
    return analyticsData;
  }

  async removeService(serviceId) {
    let domainId = this.rootStore.main.userDomain;
    let serviceStatus = await this.getServiceStatus(serviceId);
    if (serviceStatus !== "active") return;

    try {
      const deleteUrl = `https://services.airrange.io/api/manageapi?type=delete&tenant=${domainId}&service=${serviceId}`;

      // transfer the file to the server
      await axios.post(deleteUrl, {});
    } catch (error) {
      console.log("ERROR removeService", error);
    }
  }

  // =============================================
  // Get webservice data
  // =============================================

  async turnJsonIntoArrayData(data, withHeader = true) {
    if (!data || data.length === 0) return [];
    let flattenedData = [];
    // get the header keys
    const headerKeys = Object.keys(data[0]);
    if (withHeader) flattenedData.push(headerKeys);
    // get the data values
    for (const item of data) {
      let rowArray = [];
      headerKeys.forEach((headerKey) => rowArray.push(item[headerKey]));
      flattenedData.push(rowArray);
    }
    return flattenedData;
  }

  async getDataFromWebservice(
    serviceUrl,
    returnAsDataArray = false,
    withHeader = true,
  ) {
    let data;
    try {
      const response = await axios({
        url: serviceUrl,
        method: "GET",
      });
      data = response.data ?? "error";
      if (returnAsDataArray)
        data = await this.turnJsonIntoArrayData(data, withHeader);
    } catch (error) {
      console.log("ERROR getDataFromWebservice", error);
      data = "error";
    }
    return data;
  }

  async getDocumentSubmitHistory(documentId) {
    let data = [];
    const submitList =
      await this.rootStore.appsync.getDocumentSubmits(documentId);
    for (const submitItem of submitList) {
      const emailSender = submitItem.emailSender;
      const title = submitItem.title;
      const created = submitItem.created;
      const changes = submitItem.data?.changes ?? [];
      for (const change of changes) {
        let item = {
          key: change.key,
          emailSender: emailSender,
          title: title,
          created: created,
          sheetName: change.sheetName,
          address: change.address,
          oldAddress: change.oldAddress,
          value: change.newValue,
          oldValue:
            change.oldValue &&
            !["unknown", "undefined"].includes(change.oldValue)
              ? change.oldValue
              : null,
          row: change.row,
          col: change.col,
        };
        data.push(item);
      }
    }
    // sort - so that newest data is at the top
    data.sort((a, b) => {
      return new Date(a.created) - new Date(b.created);
    });
    return data;
  }
}
